import { Link } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { usePageTitle } from '../hooks/usePageTitle';

export function NotFound() {
  usePageTitle('Page Not Found');

  return (
    <Layout>
      <div className="section py-24 sm:py-36 text-center">
        <p className="font-display text-7xl sm:text-9xl font-bold text-mustard-green-dark/10 mb-4">404</p>
        <h1 className="font-display text-2xl sm:text-3xl font-bold text-mustard-green-dark mb-3 -mt-8 sm:-mt-12">
          Page not found
        </h1>
        <p className="text-slate-500 mb-8 max-w-md mx-auto">
          The page you are looking for does not exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" className="btn-primary">Back to Home</Link>
          <Link to="/programmes" className="btn-secondary">Explore Programmes</Link>
        </div>
      </div>
    </Layout>
  );
}
